import { useLocation, useOutletContext } from "react-router-dom";
import PageTitle from "@/components/PageTitle";
import { JobsOutletContext } from "@/pages/_layouts/jobs/JobPostIndexLayout";
import JobDetailsSkeleton from "@/pages/_layouts/jobs/_components/JobDetailsSkeleton";
import JobDetailsTabContent from "@/pages/_layouts/jobs/_components/JobDetailsTabContent";

export default function JobPostDetails() {
  const location = useLocation();
  const { data, loading, title } = useOutletContext<JobsOutletContext>();

  if (loading) {
    return <JobDetailsSkeleton />;
  }

  if (!data?.jobPost) return null;

  return (
    <>
      <PageTitle pattern={location.pathname} title={`${title} | Jobs | Job Post Details`} />
      <JobDetailsTabContent jobPost={data.jobPost} />
    </>
  );
}
